import { z } from 'zod';
import { Codec } from './session.js';
export const ProbeCodec = z.object({
    codec: Codec,
});
export const ProbeCodecResult = z.object({
    codec: Codec,
    ok: z.boolean(),
    reason: z.string().optional(),
});
//# sourceMappingURL=codec-probe.js.map